<!--详情页面-->
<template>
  <div class="detail-class-wrap" v-if="data">
    <!--老师的-->
    <div class="top clearfix">
      <p class="status-wrap left">
        <span>当前状态：</span>
        <span :class="{ ordering: data.status }">{{ data.status ? '开启订阅中' : '暂停订阅' }}</span>
      </p>
      <p class="action-wrap right" v-if="isRoomTeacher">
        <nuxt-link to="/vip/edit" class="btn-ask">修改特训班设置</nuxt-link>
        <nuxt-link :to="`/vip/room/${data.id}`">进入特训班</nuxt-link>
      </p>
    </div>
    <!--用户的-->
    <div class="student-top top clearfix" v-if="!isRoomTeacher && data.isBuy === 1">
      <p class="left">
        {{ authUser.userName }}，您的服务截止时间为{{ data.orderEndDate }}，<template v-if="lastDay > 0">还有<span class="red">{{ lastDay }}</span>天到期</template><template v-else><span class="red">今天到期</span></template>
      </p>
      <nuxt-link class="right" :to="`/vip/room/${data.id}`">进入特训班</nuxt-link>
    </div>

    <!--老师详情页，关闭订阅-->
    <div v-if="!data.status" class="content teacher-close">
      <div class="icon-wrap">
        <span><i class="iconfont icon-suo"></i></span>
      </div>
      <p class="tishi">
        {{ isRoomTeacher ? '您已关闭订阅，用户无法购买' : '老师暂停订阅，敬请等待下次开放，' }} <nuxt-link v-if="!isRoomTeacher" to="/vip">查看更多特训班 &#187;</nuxt-link>
      </p>
    </div>
    <!--开启订阅-->
    <div v-else class="open-order">
      <div class="top clearfix">
        <span class="left title">{{ isRoomTeacher ? '当前价格：' : '订阅周期：' }}</span>
        <ul class="left">
          <li class="item left"
            v-for="(item, index) in priceList"
            :key="item.level"
            @click="selected(item, index)"
            :class="{ dagou: !isTeacher && pickedItemIndex === index }"
            :style="{ cursor: isRoomTeacher ? 'default' : 'pointer' }">
            {{ item.level }}交易日/<span>{{ item.gcoins }}</span>G币
          </li>
        </ul>
      </div>
      <div class="youhui-wrap clearfix">
        <span class="left title">优惠信息：</span>
        <p v-if="!data.promotion" class="info left">
          暂无优惠信息
        </p>
        <p class="left info" v-else-if="data.promotion.type === 1 && data.promotion.start <= timeNow && timeNow <=  data.promotion.end">
          限时：<span class="yf-text_red">{{ data.promotion.start }}</span>至<span class="yf-text_red">{{ data.promotion.end }}</span>订阅用户可享受<span class="yf-text_red">{{ data.promotion.discount }}折优惠</span>
        </p>
        <p class="left info" v-else-if="data.promotion.type === 2">
          限额：前<span class="yf-text_red">{{ data.promotion.max }}</span>名订阅用户可享受<span class="yf-text_red">{{ data.promotion.discount }}折优惠</span>
        </p>
        <p  class="left info" v-else-if="data.promotion.type === 3 && data.promotion.start <= timeNow && timeNow <=  data.promotion.end">
          {{ data.promotion.start }}至{{ data.promotion.end }}，在本直播室{{ data.promotion.consumeType | filterType }}满<span class="yf-text_red">{{ data.promotion.gcoins }}元，</span>可享受<span class="yf-text_red">{{ data.promotion.discount }}折优惠</span>
        </p>
        <p  class="left info" v-else-if="data.promotion.end < timeNow">
          暂无优惠信息
        </p>
      </div>
      <div class="price-wrap" v-if="!isTeacher">
        <span class="left title">订阅价格：</span>
        <p class="left detail"><span>{{ pickedItem.gcoins }}</span>G币</p>
        <p class="clearfix"></p>
        <div class="discount clearfix" v-if="data.isDiscount && pickedItem.gcoins > 99 && authUser.normalLevel > 2">
          <p class="left">专享折扣：</p>
          <p class="left">实付满100可享受折上{{ authUser.normalLevel | levelDiscount }}折</p>
        </div>
        <p class="btn-wrap">
          <button type="button" :class="{ yf_warning: isTeacher }" @click="handleOrder">{{ data.isBuy === 1 ? '立即续订' : '立即订阅' }}</button>
        </p>
        <p class="tip">注意：服务期限将从订阅当天00:00算起（建议早上订阅），点击“立即订阅”后请仔细核对弹窗中的服务期限</p>
      </div>
    </div>
    <div class="bottom">
      <p class="title">特训班说明</p>
      <div class="text">{{ data.introduce }}</div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import Dialog from '@/utils/Dialog'
import { levelDiscount } from '@/utils/Filters'

export default {
  name: 'vip-detail-class',
  data () {
    return {
      teacherId: this.$route.params.id,
      pickedItem: {},				 // 默认订阅价格数据
      pickedItemIndex: 0,    // 用户的订阅选择,默认第一个
      priceList: []					 // 价格数组
    }
  },
  mounted () {
    if (this.data) {
      this.priceList = this.data.price.filter(_ => Number(_.gcoins) > 0)
    }
    if (!this.isRoomTeacher) this.pickedItem = this.priceList[0]
  },
  methods: {
    selected (item, index) {
      if (!this.isTeacher) {
        this.pickedItem = item
        this.pickedItemIndex = index
      }
    },
    handleOrder () {
      if (!this.$isLogin()) {
        Dialog.login()
        return
      }
      let params = {
        id: this.data.id,
        day: Number(this.pickedItem.level)
      }
      this.$axios._post('/Vip/Order', params).then(res => {
        Dialog.order({
          type: 1,
          title: this.data.title,
          date: `${res.startTime}至${res.endTime}（共${params.day}交易日）`,
          price: res.gcoins,
          teacher: this.data.teacherId
        }, (data, instance) => {
          // 确认订单回调函数
          params.voucher_id = data.voucher > 0 ? data.voucher : 0
          params.gcoins = data.gcoins
          this.$axios._post('/Vip/Pay', params).then(res => {
            instance.close()
            Dialog.alert(`您已成功订阅${this.data.title}`, {
              type: 'success',
              showCancelButton: true,
              cancelButtonText: '关闭继续浏览',
              confirmButtonText: '进入特训班'
            }).then(() => {
              this.$router.push(`/vip/room/${this.data.id}`)
            }).catch(() => {
              this.$store.dispatch('vip/initVipRoomData', { id: this.data.id })
            }).finally(() => {
              this.$store.commit('user/setGcoins', this.authUser.gcoins - params.gcoins)
            })
          })
        })
      })
    }
  },
  filters: {
    filterType (v) {
      switch (v) {
        case 0:
          return '累计消费'
        case 1:
          return '学堂投票'
        case 2:
          return '学堂提问'
        case 3:
          return '查看纸条'
        case 4:
          return '查看文章'
        case 5:
          return '学堂送礼'
        case 7:
          return '购买视频'
        case 9:
          return '购买VIP'
        case 10:
          return '购买付费观点'
      }
    },
    levelDiscount
  },
  computed: {
    authUser () {
      return this.$store.state.user.data
    },
    data () {
      return this.$store.state.vip.data
    },
    isTeacher () {
      // 用户是否是老师
      return this.$store.getters['user/isTeacher']
    },
    isRoomTeacher () {
      // 用户是否是当前房间老师
      return this.$store.getters['vip/isVipRoomTeacher']
    },
    // 用户剩余日期
    lastDay () {
      return moment(this.data.orderEndDate.slice(0, 10)).diff(moment(this.data.nowDate.slice(0, 10)), 'days')
    },
    //当前时间
    timeNow () {
      return moment().format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>

<style lang="less" scoped>
.detail-class-wrap {
  background: #fff; padding: 40px 50px 150px;
  .top { margin-bottom: 30px;
    .status-wrap {
      span:first-child { font-size: 14px; color: #333; margin-right: 10px;}
      span:last-child { font-size: 16px; color: #666; line-height: 52px; }
      .ordering { color: #e33a3d !important; font-weight: 600; }
    }
    .action-wrap {
      a {
        display: inline-block; width: 250px; font-size: 16px; text-align: center; line-height: 50px; border-radius: 25px;
        &:nth-child(1) { margin-right: 30px; }
        &:nth-child(2) {
          background: #e3ad41; color: #fff; border: 1px solid #e3ad41; transition: all .3s;
          &:hover {
            background-color: transparent; color: #e3ad41;
          }
        }
      }
    }
  }
  .student-top {
    background: #fdefef; line-height: 100px;
    p {
      display: inline-block; font-size: 16px; color: #835940; padding-left: 40px;
      span.red { color: #e53b3c; }
    }
    a { 
      display: inline-block; width: 188px; background: #e3ad41; line-height: 50px; border-radius: 35px; text-align: center; font-size: 18px; margin-top: 25px; margin-right: 25px; color: #fff;
    }
  }
  .content { height: 220px; background: #f2effa; margin-bottom: 26px; padding-top: 54px; text-align: center;
    .icon-wrap {
      width: 76px; height: 76px; margin: 0 auto; padding-top: 4px; background: #d7d3e4; border-radius: 50%;
      span {
        display: block; margin: auto; border: 4px solid #f2effa; border-radius: 50%; width: 68px; height: 68px;padding-top: 5px;
        i { font-size: 45px; color: #f2effa; }
      }
    }
    .tishi { font-size: 18px; color: #988eb3; padding-top: 24px;
      a { font-size: 16px; color: #c38846; }
    }
  }
  /*老师开启订阅*/
  .open-order { border-bottom: 1px solid #eee; padding-bottom: 30px;
    .top {
      .title {
        margin-right: 10px; font-size: 14px; line-height: 64px;
      }
      ul {
        li {
          position: relative; width: 233px; border: 2px solid #e5dcdf; margin-left: 20px; text-align: center; line-height: 60px; font-size: 20px;margin-top: 10px;
          &:first-child { margin-left: 0; }
          &:nth-child(5) { margin-left: 0; }
          span { color: #e43a3d; font-size: 20px; }
        }
        .dagou {
          border-color: #fb9e00;
          &:after { content: ' '; display: block; position: absolute; width: 21px; height: 21px; background: url(~assets/dagou.png) no-repeat; bottom: 0; right: 0; }
        }
      }
    }
    .youhui-wrap {
      .title { font-size: 14px; line-height: 77px; margin-right: 10px; }
      .info {
        width: 995px; padding-left: 24px; background: #fceead; line-height: 77px; font-size: 16px;
        span { font-size: 16px; font-weight: 600; }
        span.red { color: #e43a3d; font-size: 16px;}
       }
    }
    .price-wrap {
      .title { width: 86px; font-size: 14px; padding-top: 4px; line-height: 77px;}
      .detail { line-height: 77px;  font-size: 14px;
        span { color: #e43a3d; font-size: 24px; margin-right: 6px; }
      }
      .discount {
        font-size: 14px; margin-bottom: 20px; line-height: 1.6;
        p:last-child {
          margin-left: 12px; background-color: #fb9e00; color: #ffffff; padding: 0 12px; font-style: italic;
        }
      }
      .btn-wrap { padding-left: 84px;
        > button { width: 250px; height: 50px; border-radius: 35px; border: none; background: #e43a3d; font-size: 20px; color: #fff; outline: none; cursor: pointer;}
      }
      .tip { margin-left: 84px; margin-top: 20px; font-size: 14px; color: #ff33ff; }
    }
  }
  .bottom {
    padding-top: 30px;
    .title { font-size: 20px; color: #dfbe8b; }
    .text { line-height: 1.8; color: #666; padding-top: 21px; text-indent: 2em; }
  }
}
</style>
